import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Material
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';

// Modules
import { ElementsModule } from '@modules/elements/elements.module';

// Components
import { TasksJsonComponent } from './components/tasks-json/tasks-json.component';
import { TasksBoardComponent } from './components/tasks-board/tasks-board.component';
import { TasksMermaidComponent } from './components/tasks-mermaid/tasks-mermaid.component';
import { TaskDetailsComponent } from './components/task-details/task-details.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    // Materials
    MatDialogModule,
    MatIconModule,
    MatNativeDateModule,
    MatMenuModule,

    ElementsModule,
  ],
  declarations: [
    TasksJsonComponent,
    TasksBoardComponent,
    TasksMermaidComponent,
    TaskDetailsComponent,
  ],
  exports: [
    TasksJsonComponent,
    TasksBoardComponent,
    TasksMermaidComponent,
    TaskDetailsComponent,
  ]
})
export class TasksModule { }
